import { render, staticRenderFns } from "./contentUS.vue?vue&type=template&id=21778e5c&scoped=true&"
import script from "./contentUS.vue?vue&type=script&lang=js&"
export * from "./contentUS.vue?vue&type=script&lang=js&"
import style0 from "./contentUS.vue?vue&type=style&index=0&id=21778e5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21778e5c",
  null
  
)

export default component.exports